import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterDateDiff"
    ,pure: false
})
export class FilterDateDiff implements PipeTransform {
    transform(valueFrom:Date,valueTo:Date,type:string):any {
        if(!valueFrom){
            return valueFrom;
        }
        if(!valueTo){
            return valueTo;
        }
        if(!type){
            type = "day";
        }

        let secFrom:number = valueFrom.getTime() * 0.001;
        let secTo:number = valueTo.getTime() * 0.001;
        let secDiff = secTo - secFrom;
        let secDay = 60 * 60 * 24;
        let secHour = 60 * 60;
        let secMinute = 60;

        switch(type){
            case "hour":
                return Math.floor(secDiff / secHour);
            case "minute":
                return Math.floor(secDiff / secMinute);
            case "second":
                return Math.floor(secDiff);
            case "day":
            default:
                return Math.floor(secDiff / secDay);
        }
    }
}
